<template>
<div class="vpn-download">
  <HeadNav selectedLanguage="en" page="download" />
  <main class="vpn-download__main">
    <DownloadHeroSection />
    <!-- 与 Hero shell 同宽的连续正文栏，消除上下错位感 -->
    <div class="vpn-download__body">
      <ApkInfoSection />
      <ApkSafetySection />
      <SetupSection />
      <DownloadNoticeSection />
    </div>
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss';
import HeadNav from '@/components/HeadNav.vue';
import DownloadHeroSection from '@/components/vpn/DownloadHeroSection.vue';
import ApkInfoSection from '@/components/vpn/ApkInfoSection.vue';
import ApkSafetySection from '@/components/vpn/ApkSafetySection.vue';
import SetupSection from '@/components/vpn/SetupSection.vue';
import DownloadNoticeSection from '@/components/vpn/DownloadNoticeSection.vue';

export default {
  name: 'Download',
  components: {
    HeadNav,
    DownloadHeroSection,
    ApkInfoSection,
    ApkSafetySection,
    SetupSection,
    DownloadNoticeSection,
  },
  mounted() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('vpn-site');
    }
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('vpn-site');
    }
  },
};
</script>

<style lang="scss" scoped>
.vpn-download {
  min-height: 70vh;
  background: transparent;
}

.vpn-download__main {
  width: 100%;
}

// 与 Hero shell 同宽：min(1120px, 92%)
.vpn-download__body {
  width: var(--vpn-content-width);
  max-width: 100%;
  margin: 28px auto 48px;
  display: grid;
  gap: 20px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .vpn-download__body {
    width: 100%;
    margin: 16px 0 32px;
    padding: 0 16px;
    gap: 14px;
  }
}

@media (max-width: 480px) {
  .vpn-download__body {
    margin: 12px 0 28px;
    padding: 0 12px;
    gap: 12px;
  }
}
</style>
